module.exports = __webpack_public_path__ + "static/media/poste_9.4797c8e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_9.jpg
// module id = 266
// module chunks = 0